import { Injectable } from '@angular/core';
import { Observable, delay, throwError, of } from 'rxjs';

import { AuthErrorResponse, LoginRequest, LoginResponse } from '../models';

const MOCK_STUDENT_ACCOUNT = {
  identifierOptions: ['2110310001', 'student001@uneti.edu.vn'],
  password: '123456',
  user: {
    id: 'stu_001',
    studentCode: '2110310001',
    fullName: 'Nguyễn Văn A',
    email: 'student001@uneti.edu.vn',
    roles: ['student'],
    status: 'active',
  },
} as const;

@Injectable({ providedIn: 'root' })
export class MockAuthService {
  login(request: LoginRequest): Observable<LoginResponse> {
    const identifier = request.identifier.trim().toLowerCase();
    const isKnownIdentifier = MOCK_STUDENT_ACCOUNT.identifierOptions.some((option) => option.toLowerCase() === identifier);

    if (!isKnownIdentifier || request.password !== MOCK_STUDENT_ACCOUNT.password) {
      return throwError((): AuthErrorResponse => ({ code: 'INVALID_CREDENTIALS' })).pipe(delay(250));
    }

    return of({
      accessToken: 'mock-student-access-token',
      expiresAt: new Date(Date.now() + 60 * 60 * 1000).toISOString(),
      user: MOCK_STUDENT_ACCOUNT.user,
    }).pipe(delay(250));
  }
}
